// extracted by mini-css-extract-plugin
module.exports = {"pill":"OptionPill_pill__wd6x8","active":"OptionPill_active___4g9j"};